<script>
import { Doughnut, mixins } from "@/utils/BaseCharts"
const { reactiveProp } = mixins

export default {
    extends: Doughnut,
    mixins: [reactiveProp],
    props: ["options"],
    mounted() {
        this.renderChart(
            this.chartData,
            Object.assign({ responsive: true, maintainAspectRatio: false }, this.options)
        )
    },
    watch: {
        options: {
            handler(newOption, oldOption) {
                this.renderChart(this.chartData, this.options)
            },
            deep: true,
        },
    },
}
</script>
